import React from 'react';

export const missingPageWarning = (additionalClass?: string) => {
  return (
    <div className={`input-warning ${additionalClass}`}>
      PLEASE ENTER VALUES FOR ALL FIELDS
      </div>
  );
};
